import React from 'react';

// "Más": cuenta actual y cierre de sesión.
export function MasMobile({ usuario, inicial, onLogout }) {
  return (
    <>
      <h1 className="m-titulo-pagina">Más</h1>

      <div className="m-cuenta">
        <span className="m-avatar lg" aria-hidden="true">{inicial}</span>
        <div className="m-cuenta-datos">
          <div className="m-cuenta-nombre">{usuario.name || usuario.email}</div>
          <div className="m-cuenta-email" title={usuario.email}>{usuario.email}</div>
          {usuario.externo && <span className="m-chip">Acceso externo</span>}
        </div>
      </div>

      <button type="button" className="m-btn m-btn-peligro m-btn-bloque" onClick={onLogout}>
        <i className="ti ti-logout" aria-hidden="true"></i>
        Cerrar sesión
      </button>

      <p className="m-pie">
        Las funciones administrativas completas están en la versión de escritorio.
      </p>
    </>
  );
}
